"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketPlaceClient = void 0;
const axios_1 = __importDefault(require("axios"));
const InscriptionError_1 = require("./InscriptionError");
class MarketPlaceClient {
    constructor(key = "", environment = "live") {
        this.api_key = key;
        this.env = environment;
        const createInstance = () => {
            const headers = {
                Connection: "Keep-Alive",
                "Content-Type": "application/json",
            };
            if (this.api_key) {
                headers["x-api-key"] = this.api_key;
            }
            const client = axios_1.default.create({
                baseURL: this.env === "live"
                    ? `https://api.ordinalsbot.com/marketplace/`
                    : `https://testnet-api.ordinalsbot.com/marketplace/`,
                headers: headers
            });
            client.interceptors.response.use(({ data }) => ("data" in data ? data.data : data), (err) => {
                if (axios_1.default.isAxiosError(err)) {
                    throw new InscriptionError_1.InscriptionError(err.message, err.response?.statusText, err.response?.status);
                }
                if (err instanceof Error)
                    throw err;
                return err;
            });
            return client;
        };
        this.instanceV1 = createInstance();
    }
    async createMarketPlace(createMarketplaceRequest) {
        return this.instanceV1.post(`/create-marketplace`, {
            ...createMarketplaceRequest,
        });
    }
    async createListing(createListingRequest) {
        return this.instanceV1.post(`/create-listing`, {
            ...createListingRequest,
        });
    }
    async createOffer(createOfferRequest) {
        return this.instanceV1.post(`/create-offer`, {
            ...createOfferRequest,
        });
    }
    async submitOffer(submitOfferRequest) {
        return this.instanceV1.post(`/submit-offer`, {
            ...submitOfferRequest,
        });
    }
    async confirmPaddingOutputs(confirmPaddingOutputsRequest) {
        return this.instanceV1.post(`/confirm-padding-outputs`, {
            ...confirmPaddingOutputsRequest,
        });
    }
    async setupPaddingOutputs(setupPaddingOutputsRequest) {
        return this.instanceV1.post(`/setup-padding-outputs`, {
            ...setupPaddingOutputsRequest,
        });
    }
    async getListing(getListingRequest) {
        return this.instanceV1.post(`/get-listing`, { ...getListingRequest });
    }
    async saveListing(saveListingRequest) {
        return this.instanceV1.patch(`/save-listing/${saveListingRequest.ordinalId}`, {
            ...saveListingRequest,
        });
    }
    async transfer(transferRequest) {
        return this.instanceV1.post(`/transfer-ordinal`, {
            ...transferRequest,
        });
    }
}
exports.MarketPlaceClient = MarketPlaceClient;
//# sourceMappingURL=marketplace_client.js.map